import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { StaticQuery, graphql } from 'gatsby';

import '../assets/sass/business-casual.scss';
import Footer from './Footer';
import SiteHeader from './SiteHeader';
import Header from './Header';

class Layout extends Component {
  render() {
    const {
      children,
      noHeader,
      noFooter,
      noSiteHeader,
      activeLink,
    } = this.props;
    return (
      <StaticQuery
        query={graphql`
          query SiteTitleQuery {
            site {
              siteMetadata {
                title
              }
            }
          }
        `}
        render={data => (
          <>
            <div className={'page-top, main-content'}>
            {!noHeader ? <Header activeLink={activeLink} /> : null}
              {/* {!noSiteHeader ? <SiteHeader /> : null} */}
              <div className="main-content-body">
                {children}
              </div>
              {!noFooter ? <Footer /> : null}
            </div>
            <div className="radial-bg"/>
          </>
        )}
      />
    );
  }
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  noFooter: PropTypes.bool,
  noHeader: PropTypes.bool,
  noSiteHeader: PropTypes.bool,
  activeLink: PropTypes.string,
};

export default Layout;
